<template>
  <div id="app-root">
    <!-- Marketing pages (referral landing) render in a blank layout: no app shell,
         no PullToRefresh transform wrapper — the landing needs body scroll plus
         working position:sticky/fixed for its scroll-driven animations. -->
    <RouterView v-if="isBlankLayout" />
    <AppLayout v-else />
    <CaptchaPopup />
    <!-- Баннер согласия: раньше аналитики и виджета поддержки, потому что они
         не грузятся до выбора (см. shared/consent.ts). -->
    <CookieConsent />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import AppLayout from '@/layouts/AppLayout.vue'
import CaptchaPopup from '@/shared/components/CaptchaPopup.vue'
import CookieConsent from '@/components/common/CookieConsent.vue'

const route = useRoute()
const isBlankLayout = computed(() => route.meta?.layout === 'blank')
</script>
